import classNames from 'classnames';
import { Flex, FlexProps } from 'yoso';
import './BaseLayout.scss';

export type BaseLayoutProps = FlexProps;

export const BaseLayout = ({ children, className }: BaseLayoutProps) => (
  <Flex className={classNames('base-layout', className)} container direction="column">
    {children}
  </Flex>
);
